module.exports = __webpack_public_path__ + "img/man.3c284f6c.png";